import { useListIntegrationsV2 } from '@api';
import { useListStandingAccessReports } from '@StandingAccess/services/standingAccessQueries';
import { StandingAccessReportItem } from '@StandingAccess/types';

export default function useStandingAccessReports() {
  const { reports, isFetched, refetch, isRefetching } = useListStandingAccessReports({
    refetchInterval: 10 * 1000,
  });
  const { integrations, configs, isIntegrationsFetched } = useListIntegrationsV2();

  const list: StandingAccessReportItem[] = [];
  reports.forEach((report) => {
    const integration = integrations.find((i) => i.id === report.integration_id);
    const integrationConfig = configs.find((i) => i.type === integration?.type);

    list.push({
      report,
      integration:
        integration && integrationConfig
          ? {
              id: integration.id,
              name: integration.name,
              type: integration.type,
              typeIcon: integrationConfig.icons.svg,
            }
          : undefined,
    });
  });

  return {
    reports: list,
    isFetched: isFetched && isIntegrationsFetched,
    refetch,
    isRefetching: isRefetching || !isIntegrationsFetched,
  };
}
